module.exports = __webpack_public_path__ + "static/avatar.f0bfc962.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Article/Author/avatar.jpg
// module id = 577
// module chunks = 146451445218038